import React from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";

const MetadataRequiredMark = () => (
  <Typography
    component="span"
    color="error"
    aria-hidden="true"
    sx={{ pl: 0.25 }}
  >
    *
  </Typography>
);

/** Slightly larger than MUI helper default (~12px), aligned with 14px field copy. */
const metadataFieldErrorFormHelperTextProps = {
  sx: { fontSize: "14px", lineHeight: 1.43 },
};

export { MetadataRequiredMark, metadataFieldErrorFormHelperTextProps };
